/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Collapse, Modal, ModalBody } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import "bootstrap/dist/css/bootstrap.min.css";
import CardFooter from "components/Card/CardFooter.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import KeyboardIcon from '@material-ui/icons/Keyboard';
import Button from "components/CustomButtons/Button.js";
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import TSSelect from "components/Forms/TSSelect2";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { width } from "@material-ui/system";
import { Save } from "@material-ui/icons";
import { Checkbox } from "@material-ui/core";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
  iconFile: {
    width: "32px",
    maxWidth: "100%"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function VaccineEventList() {
  var moment = require('moment');
  require('moment/locale/th');

  useEffect(() => {


     

  }, []);


  return (
      <GridContainer>
            <GridItem xs={12} sm={12} md={12} >
                <Card>
                      <CardHeader color="warning" stats icon>
                              <h4 style={{ color: 'black' }}> รายการวัคซีน </h4>
                              <CardIcon color="info">
                                  <Icon>
                                      <KeyboardIcon />
                                  </Icon>
                              </CardIcon>
 
                          </CardHeader>
             
                      <CardBody>
                        <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                              <a href="event/4" >โรงงาน TRS เข็ม 2 ณ โรงงาน 31 ก.ค. 2564</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/5" >โรงงาน TRS เข็ม 1 ณ โรงงาน 31 ก.ค. 2564 (210 คน)</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/6" >สภาอุตสาหกรรมตรัง เข็ม 1 โรบินสัน อาทิตย์ 1 ส.ค. 2564</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/9" >อบจ. โรบินสัน อาทิตย์ 1 ส.ค. 2564</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/10" >อบจ. รร.เรือ จันทร์ 2 ส.ค. 2564</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/11" >อบจ. รร.เรือ อังคาร 3 ส.ค. 2564</a>
                          </GridItem>
            
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/12" >TRS เข็ม 2 ที่ยังไม่ฉีด ย้ายไป รร เรือ วันที่ 2</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/13" > สภาอุตสาหกรรมตรัง เข็ม 2 28 ส.ค.</a>
                          </GridItem>
               <GridItem xs={12} sm={12} md={12}>
                              <a href="event/14" >อบจ. รร.เรือ เข็ม 2 28 ส.ค.</a>
                          </GridItem>
               <GridItem xs={12} sm={12} md={12}>
                              <a href="event/15" >อบจ. รร.เรือ เข็ม 2 29 ส.ค.</a>
                          </GridItem>
               <GridItem xs={12} sm={12} md={12}>
                              <a href="event/16" >TRS เข็ม 2 ฉีดที่ผิวหนัง วันที่ 6 สค</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/17" >TRS เข็ม 1 ฉีดที่ผิวหนัง วันที่ 6 สค</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/22" >อบจ รร.เรือ รอบ2 เข็ม 1 11 ส.ค.64</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/24" >อบจ รร.เรือ รอบ3 เข็ม 1 18 ส.ค.64</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/25" >อบจ รร.เรือ รอบ3 เข็ม 1 19 ส.ค.64</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/19">[19]อบจ รร.เรือ รอบแรกเข็ม 2 - 30 ส.ค.64</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/23">[23]อบจ รร.เรือ รอบสอง เข็ม 2 - 7 ก.ย.64</a> - <a href="dashboard/23" target="_blank">Dashboard</a>   
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/26">[26]อบจ รร.เรือ เข็ม 2 (13 ก.ย.64)</a> - <a href="dashboard/26" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/27">[27]อบจ รร.เรือ เข็ม 2 (14 ก.ย.64)</a> - <a href="dashboard/27" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/32">[32] อบจ เข็ม 1 รอบเก็บตก  20 กย. 64</a> - <a href="dashboard/32" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/33">[33] อบจ เข็ม 2 รอบเก็บตก  11 ตค. 64</a> - <a href="dashboard/33" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/34">[34] มหิดล เข็ม 1 24 ก.ย. 64</a> - <a href="dashboard/32" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/36">[36] นักเรียน 7 ตค เข็ม 1</a> - <a href="dashboard/36" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/37">[37] นักเรียน 8 ตค เข็ม 1</a> - <a href="dashboard/37" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/38">[38] นักเรียน 9 ตค เข็ม 1</a> - <a href="dashboard/38" target="_blank">Dashboard</a>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event/42">[42] Sinovac 15 ตค เข็ม 1</a> - <a href="dashboard/42" target="_blank">Dashboard</a>
                          </GridItem>


                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/49">[44] นักเรียนล็อต2 18 ตค เข็ม 1</a> - <a href="dashboard/44" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/45">[45] นักเรียนล็อต2 19 ตค เข็ม 1</a> - <a href="dashboard/45" target="_blank">Dashboard</a>
                          </GridItem>


                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/39">[39] นักเรียน 1 พย เข็ม 2</a> - <a href="dashboard/39" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/40">[37] นักเรียน 2 พย เข็ม 2</a> - <a href="dashboard/40" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/41">[38] นักเรียน 2 พย เข็ม 2</a> - <a href="dashboard/41" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/46">[38] นักเรียน 8 พย เข็ม 2</a> - <a href="dashboard/46" target="_blank">Dashboard</a>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                              <a href="event3/47">[38] นักเรียน 9 พย เข็ม 2</a> - <a href="dashboard/47" target="_blank">Dashboard</a>
                          </GridItem>


             
                        </GridContainer>

                      </CardBody>
                      <CardFooter>

                      </CardFooter>
                </Card>
            </GridItem>
    </GridContainer>
  );
}
